import { createSlice } from "@reduxjs/toolkit";
import { User, UserSetting } from "../global/types";

type AuthSliceState = {
    settings: UserSetting | null;
}

const initialState: AuthSliceState = {
    settings: null,
}

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setSettings: (state, action) => {
            state.settings = action.payload;
        }
    },
    selectors: {
        selectSettings: (state) => state.settings,
    }
});

export const { setSettings } = authSlice.actions;
export const { selectSettings } = authSlice.selectors;
export default authSlice.reducer;
